import { ExternalLink } from "lucide-react"

export const VideoSection = ({ videoUrl }) => {
  return (
    <div>
      <h4 className="font-medium text-gray-900 mb-2">Video</h4>
      <div className="flex items-center gap-2">
        <a
          href={videoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#f06292] hover:text-[#e91e63] font-medium flex items-center gap-1"
        >
          <ExternalLink className="w-4 h-4" />
          {videoUrl}
        </a>
      </div>
    </div>
  )
}
